import { setIn } from "immutable";
import uuid from "uuid/v1";
import { DEFAULT_GOAL } from "lib/globals";

export const SET_ITEM = "SET_ITEM";
export const NEW_GOAL = "NEW_GOAL";
export const DELETE_GOAL = "DELETE_GOAL";
export const NEW_BUNDLE = "NEW_BUNDLE";
export const DELETE_BUNDLE = "DELETE_BUNDLE";
export const DISCARD = "DISCARD";
export const CampaignReducer = (default_language = "english") => {
	return (state, { type, path, value }) => {
		switch (type) {
			case DISCARD:
				return { ...value };
			case SET_ITEM:
				return setIn(state, path.split("."), value);
			case NEW_BUNDLE:
				return setIn(
					state,
					["settings", "bundles", "list"],
					state.settings.bundles.list.concat([
						{
							id: uuid(),
							type: "percentage",
							reward: "",
							quantity: ""
						}
					])
				);
			case DELETE_BUNDLE:
				return setIn(
					state,
					["settings", "bundles", "list"],
					state.settings.bundles.list.filter(({ id }) => id !== value)
				);
			case NEW_GOAL:
				return setIn(
					state,
					["settings", "add_to_unlock", "goals"],
					state.settings.add_to_unlock.goals.concat(
						DEFAULT_GOAL(state.settings.add_to_unlock, default_language)
					)
				);
			case DELETE_GOAL:
				let newGoals = state.settings.add_to_unlock.goals.slice(0);
				newGoals.splice(value, 1);
				return setIn(state, ["settings", "add_to_unlock", "goals"], newGoals);
			default:
				return state;
		}
	};
};
